import { languages } from "country-data";
import { isRecord } from "../types/data";

const normalizeText = (value: unknown) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/[().,]/g, "")
    .replace(/\s+/g, " ");

const LANGUAGE_ALIASES = new Map<string, string>();

(languages?.all || []).forEach((language) => {
  const code = String(language?.alpha2 || language?.alpha3 || "").toLowerCase();
  if (!code) return;
  [
    language.alpha2,
    language.alpha3,
    language.bibliographic,
    language.name
  ].map(normalizeText).filter(Boolean).forEach((alias) => {
    if (!LANGUAGE_ALIASES.has(alias)) LANGUAGE_ALIASES.set(alias, code);
  });
});

[
  ["русский", "ru"],
  ["английский", "en"],
  ["французский", "fr"],
  ["немецкий", "de"],
  ["испанский", "es"],
  ["итальянский", "it"],
  ["японский", "ja"],
  ["корейский", "ko"],
  ["китайский", "zh"],
  ["арабский", "ar"],
  ["португальский", "pt"],
  ["хинди", "hi"]
].forEach(([alias, code]) => LANGUAGE_ALIASES.set(alias, code));

const getRawLanguageValue = (value: unknown) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (!isRecord(value)) return "";
  return (
    value.iso_639_1 ||
    value.alpha2 ||
    value.alpha3 ||
    value.code ||
    value.english_name ||
    value.name ||
    ""
  );
};

export const getLanguageCode = (value: unknown) => {
  const rawValue = String(getRawLanguageValue(value) || "").trim();
  if (!rawValue || /^(undefined|null|nan)$/i.test(rawValue)) return "";
  const normalized = normalizeText(rawValue);
  const baseCode = normalized.match(/^([a-z]{2,3})(?:[-_][a-z]{2,4})?$/)?.[1] || "";
  return LANGUAGE_ALIASES.get(normalized) ||
    LANGUAGE_ALIASES.get(baseCode) ||
    baseCode;
};
